<template>
  <div style="background: #fbfbfb; padding-bottom: 40px">
    <div class="soluBanner">
      <el-carousel
        indicator-position="none"
        :interval="5000"
        :height="imgHeight + 'px'"
      >
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">
            <img :src="item.value" alt="" style="width: 100%" ref="image"/>
          </a>
          <a v-else href="javascript:void(0)">
            <img :src="item.value" alt="" style="width: 100%" ref="image"/>
          </a>
          <!-- <div class="soluBanBox"> -->
          <!--            <h2>解决方案</h2>
            <div class="soluBanText">
              <p>丰富的行业解决方案，案例覆盖各个领域，3D打印智造未来。</p>
              <p>
                RICH INDUSTRY SOLUTIONS AND CASES COVER ALL FIELDS,AND 3D
                PRINTING INTELLIGENTLY CREATES THE FUTURE
              </p>
            </div>-->
          <!--<button @click="getCallOur">联系我们</button>-->
          <!-- </div> -->
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="soluBottomRTit flex">
      <div class="soluBottomRFlex flex">
        <div class="soluBottomRTit2">
          <p>解决方案</p>
          <i class="soluBottomRTit2_i"></i>
        </div>

        <i class="el-icon-arrow-right gray"> </i>

        <div class="soluBottomRTit2 gray">
          <p>{{ solutionTitle }}</p>
        </div>
      </div>
      <div class="soluBottomInput">
        <input type="text" placeholder="输入关键词" v-model="searchtitle" />
        <i class="el-icon-search"></i>
      </div>
    </div>

    <div class="soluBottom flex">
      <div class="soluBottomL">
        <p class="soluBottomLTit" @click="getSoluTabs">解决方案</p>
        <div class="soluBottomLtab">
          <p
            v-for="(items, index) in soluLeft"
            :key="index"
            @click="getSoluTbas(index)"
          >
            <!-- <i
              class="soluBottomLtab_active"
              v-show="soluTabsIndex == index ? true : false"
            ></i> -->
            <span :class="soluTabsIndex == index ? 'p_active' : ''">{{
              items.title
            }}</span>
          </p>
        </div>
      </div>

      <div class="soluBottomR">
        <div class="suluBottomBig" v-if="solutionList.length != 0">
          <div
            class="soluBottomRList flex"
            v-for="(items, index) in solutionList"
            :key="index"
            @click="getSolutionDetail(items.uuid)"
          >
            <div class="soluBottomRImg">
              <!--<img src="../../assets/sulutionLi.png" alt="" />-->
              <img :src="items.thumbnailUrl" alt="" />
            </div>
            <div class="soluBottomRMess">
              <h4>{{ items.name }}</h4>
              <p class="soluBottomRMess_p">
                {{ items.description }}
              </p>
              <div class="flex soluBottomRMess_div">
                <span>{{ items.createTime }}</span>
                <div class="flex soluBottomRMess_div2">
                  <i class="iconfont">&#xe611;</i>

                  <span>{{ items.viewNum }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="suluBottomBig2">
			<!-- 暂无数据 -->
			<img src="../../assets/暂无搜索内容.jpg" style="width: 200px;" >
			</div>
        <!-- 分页 -->
        <div class="pageina">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="current"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getProgramList,
  getSolutionList,
  getBannerList,
} from "../../utils/interface";
import { mapState } from "vuex";

export default {
  //   解决方案
  name: "solution",
  metaInfo: {
    title: '解决方案- 提供整套行业和技术解决方案-增材云', // set a title
    meta: [{                 // set meta
      name: 'keywords',
      content: '工业互联网 | 智能制造 | 增材制造 | 3D解决方案 | 生产制造 | 运维服务 | 3D打印原理'
    },{                 // set meta
      name: 'description',
      content: '增材云面向增材制造领域业务场景，提供整套行业和技术解决方案，为行业用户提供需求发布、设计、建模、打印、交流互动于一体的多种应用场景服务。'
    }],
  },
  components: {},
  data() {
    return {
      imgHeight: "",
      imgHeightsetIn: null,
      groupCode: "SOLUTION_BANNER", // 类别
      survival: "ENABLE", // 状态(ENABLE:启用;DISABLE:停用;VERIFY:验证中;)
      current: 1, // 起始页
      pageSize: 10, // 分页条数
      programUuid: "", // 类别id
      programName: "", // 类别名称
      status: "RELEASE", // 状态(HIDE:隐藏;DRAFT:草稿;RELEASE:发布;)
      soluLeft: [],
      solutionList: [],
      // 分页
      currentPage4: 1,
      total: 0,
      soluTabsIndex: null,
      // banner列表
      bannerList: [],
      solutionTitle: "全部",
      timer: null,
      setIn: null,
      searchtitle: "",
    };
  },
  created() {
    this.searchtitle = this.$route.query.solutionInput;
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.getBannerList();
        this.getProgramList();
        this.getSolutionList();
      }
    }, 500);
  },
  watch: {
    searchtitle() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.getSolutionList();
      }, 100);
    },
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("resize", () => {
      this.imgHeight = this.$refs.image[0].height;
    });
  },
  methods: {
    imgLoad() {
      this.$nextTick(function () {
        // 获取窗口宽度*图片的比例，定义页面初始的轮播图高度
        // this.imgHeight = (document.body.clientWidth * 1) / 4;
        this.imgHeightsetIn = setInterval(() => {
          if (this.imgHeight == 0) {
            this.imgHeight = this.$refs.image[0].height;
            // console.log(5555, this.imgHeight);
          } else {
            clearInterval(this.imgHeightsetIn);
            // console.log(6666, this.imgHeight);
          }
        }, 520);
      });
    },
    getProgramList() {
      let params = {
        name: "",
        survival: this.survival,
        current: 1,
        pageSize: 10,
      };
      getProgramList(params).then((res) => {
        if (res.success) {
          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              let leftInfo = {};
              leftInfo.id = res.data[i].uuid;
              leftInfo.title = res.data[i].label;
              this.soluLeft.push(leftInfo);
            }
          }
        }
      });
    },
    getSolutionList() {
      let params = {
        name: this.searchtitle,
        status: this.status,
        programUuid: this.programUuid,
        programName: this.programName,
        current: this.current,
        pageSize: this.pageSize,
      };
      getSolutionList(params).then((res) => {
        if (res.success) {
          this.solutionList = res.data;
          this.total = res.total;
        }
      });
    },
    getBannerList() {
      let params = {
        groupCode: this.groupCode,
      };
      getBannerList(params).then((res) => {
        this.bannerList = res;
        this.imgLoad();
      });
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getSolutionList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.current = val;
	  window.scrollTo(0,0);
      this.getSolutionList();
    },
    getSoluTabs() {
      this.solutionTitle = "全部";
      this.soluTabsIndex = null;
      this.programUuid = "";
      this.searchtitle = "";
      this.getSolutionList();
    },
    getSoluTbas(i) {
      this.soluTabsIndex = i;
      this.solutionTitle = this.soluLeft[this.soluTabsIndex].title;
      this.programUuid = this.soluLeft[i].id;
      this.searchtitle = "";
      this.getSolutionList();
    },
    getSolutionDetail(uuid) {
      let routeData = this.$router.resolve({
        name: "solutionDetails",
        params: { uuid: uuid },
      });
      window.open(routeData.href, "_blank");
      //this.$router.push({ name: "solutionDetails", params: { uuid: uuid } });
    },
    getCallOur() {
      this.$router.push("/solutionDetails?#tabs");
      // this.$router.push({path: '/solutionDetails', query:{stage: stage}});
    },
  },
};
</script>

<style scoped lang="less">
.blue {
  color: #1181ff;
}
.gray {
  color: #777;
  margin-right: 5px;
}
.soluBanner {
  // height: 500px;
  width: 100%;
  background: #efefef;
  margin-bottom: 0.5rem;
  position: relative;
  img {
    // height: 500px;
    width: 100%;
  }
  .soluBanBox {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1200px;
    transform: translate(-50%, -50%);
    color: #fff;
    h2 {
      font-size: 38px;
      letter-spacing: 10px;
    }
    .soluBanText {
      margin: 8px 0 60px;
      p:nth-child(1) {
        font-size: 17px;
      }
      p:nth-child(2) {
        font-size: 9px;
      }
    }
    button {
      border: 1px solid #fff;
      border-radius: 30px;
      color: #fff;
      background: none;
      padding: 2px 5px;
    }
  }
}
.soluBottomRTit {
  width: 1200px;
  margin: 0 auto;
  padding: 30px 0 0;
  line-height: 12px;
  border-bottom: 1px solid #efefef;
  justify-content: space-between;
  // align-items: center;
  .soluBottomInput {
    position: relative;
    input {
      border: none;
      background: #efefef;
      padding: 5px 13px;
      border-radius: 30px;
      height: 20px;
      width: 158px;
      font-size: 12px;
      color: #969696;
    }
    i {
      position: absolute;
      right: 5%;
      top: 50%;
      color: #969696;
      transform: translate(0, -50%);
    }
  }
  .soluBottomRTit2 {
    text-align: left;
    width: 72px;
    .soluBottomRTit2_i {
      display: inline-block;
      background: #1181ff;
      width: 20px;
      height: 2px;
    }
  }
}
.soluBottom {
  width: 1200px;
  margin: 20px auto 0;
  .soluBottomL {
    border-radius: 10px;
    width: 300px;
    flex-shrink: 0;
    .soluBottomLTit {
      cursor: pointer;
      font-size: 18px;
      color: #fff;
      background: #1181ff;
      text-align: center;
      height: 80px;
      // border-radius: 10px;
      line-height: 80px;
    }
    .soluBottomLtab {
      font-size: 14px;
      text-align: center;
      border: 1px solid #efefef;
      // border-radius: 10px;
      box-shadow: 0px 1px 7px 0px #dadada;

      p {
        cursor: pointer;
        height: 58px;
        line-height: 58px;
        border-bottom: 1px solid #efefef;
        display: flex;
        align-items: center;
        justify-content: center;
        // span {
        //   margin-left: 10px;
        // }
      }
      p:nth-last-child(1) {
        border-bottom: none;
      }
      .p_active {
        width: 100%;
        background: #e7f2ff;
      }
    }
    // .soluBottomLtab_active {
    //   background: #1181ff;
    //   height: 15px;
    //   width: 3px;
    //   display: inline-block;
    // }
  }

  .soluBottomR {
    margin-left: 28px;
    width: 100%;
    .suluBottomBig2 {
      margin-left: 28px;
      width: 100%;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      color: #d4d4d4;
      line-height: 650%;
    }
    .suluBottomBig {
      flex-wrap: wrap;
      justify-content: space-between;

      .soluBottomRList {
        cursor: pointer;
        background: #fff;
        margin-bottom: 18px;
        padding: 15px;
        border-radius: 10px;
        // height: 120px;
        .soluBottomRImg {
          // margin-top: 15px;
          width: 260px;
          height: 132px;
          margin-right: 18px;
          flex-shrink: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .soluBottomRMess {
          position: relative;

          h4 {
            font-weight: 400;
            font-size: 15px;
          }
          .soluBottomRMess_p {
            color: #777;
            font-size: 12px;
            margin-top: 15px;
            line-height: 22px;
            display: -webkit-box;
            overflow: hidden;
            white-space: normal !important;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
          .soluBottomRMess_div {
            font-size: 12px;
            color: #b7b7b7;
            align-items: center;
            position: absolute;
            bottom: 0;
            .soluBottomRMess_div2 {
              align-items: center;
              margin-left: 10px;

              i {
                margin-right: 5px;
              }
            }
          }
        }
      }
      .soluBottomRList:hover {
        box-shadow: 0px 1px 7px 0px #dadada;
      }
    }
    .pageina {
      margin-top: 74px;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/solution/index.vue